// Based on: http://jsfiddle.net/NVX3S/2/

import {Doughnut} from 'vue-chartjs';

export default {
    name: 'PieChart',
    extends: Doughnut,
    props: {
        fill: {
            type: Number,
            default: 0.4,
        },
        total: {
            type: Number,
            default: 1,
        },
        fillColor: {
            type: String,
            default: '#375278',
        },
        emptyColor: {
            type: String,
            default: '#6d9ee1',
        },
    },
    data: () => {
        return {
            chartOptions: {
                cutoutPercentage: 85, // Make the chart have a large hole for the content

                animation: false,
                title: {
                    display: false
                },
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: false
                },
                hover: {
                    mode: null,
                },
                responsive: true,
            },
        };
    },
    watch: {
        fraction: 'updateChart',
        total: 'updateChart',
    },
    methods: {
        updateChart: function () {
            const remainder = this.total - Math.abs(this.fill);
            const dataset = {
                backgroundColor: [this.fillColor, this.emptyColor],
                data: [this.fill, remainder],
            };
            if (this.fill < 0) {
                dataset.backgroundColor.reverse();
                dataset.data.reverse();
            }
            this.renderChart({datasets: [dataset]}, this.chartOptions);
        }
    },
    mounted() {
        // Render chart
        this.updateChart();
    },
};



// WEBPACK FOOTER //
// ./src/components/widgets/quick-insights/PieChart.js